import type { VariantProps } from 'class-variance-authority';
import { cva } from 'class-variance-authority';

// File is DialogRoot.vue (the `Dialog` SFC name is HTML-reserved and single-word,
// which trips vue/no-reserved-component-names + multi-word rules); the public
// name stays `Dialog` to match the sheet/popover import idiom.
export { default as Dialog } from './DialogRoot.vue';
export { default as DialogClose } from './DialogClose.vue';
export { default as DialogContent } from './DialogContent.vue';
export { default as DialogDescription } from './DialogDescription.vue';
export { default as DialogFooter } from './DialogFooter.vue';
export { default as DialogHeader } from './DialogHeader.vue';
export { default as DialogTitle } from './DialogTitle.vue';
export { default as DialogTrigger } from './DialogTrigger.vue';

// Surface + scrim come from the overlay role tokens, elevation from
// --ring-popover — all flip under .dark, so there are no dark: variants here.
// Sizes cover the spread found in the 19 hand-rolled modals (ITDEVELOP-2721):
// sm = confirmations, md = forms (the 32rem ShareWithAffected class), lg = the
// wide manager/user modals.
export const dialogVariants = cva(
    'gap-md p-md fixed top-1/2 left-1/2 z-60 flex max-h-[85vh] w-[90%] -translate-x-1/2 -translate-y-1/2 flex-col overflow-y-auto rounded-md bg-[var(--overlay-surface)] shadow-[var(--ring-popover)] data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95',
    {
        variants: {
            size: {
                sm: 'max-w-[24rem]',
                md: 'max-w-[32rem]',
                lg: 'max-w-[50rem]',
            },
        },
        defaultVariants: {
            size: 'md',
        },
    },
);

export type DialogVariants = VariantProps<typeof dialogVariants>;
